// const scroll = new LocomotiveScroll({
//   el: document.querySelector("#MainContent"),
//   smooth: true,
// });

// Navbar
try {
  let navbar = document.querySelector(".custom-header-wrapper");

  function applyScrolledState() {
    navbar.classList.add("scrolled");
  }

  function removeScrolledState() {
    navbar.classList.remove("scrolled");
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY > 20) {
      applyScrolledState();
    } else {
      removeScrolledState();
    }
  });
} catch (error) {
  console.log(error);
}

// Video AutoPlay
try {
  const videos = document.querySelectorAll(".lazy-video");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;

        video.muted = true;
        video.play().catch(() => {});
        // video.click().catch(() => {});

        observer.unobserve(video);
      }
    });
  });

  videos.forEach((v) => observer.observe(v));

  // document.addEventListener("DOMContentLoaded", () => {
  //   document
  //     .querySelectorAll(".deferred-media__poster-button")
  //     .forEach((btn) => {
  //       // console.log(btn);
  //       btn.click();
  //     });
  // });
} catch (error) {
  console.log(error);
}

//Cart Drawer Toggle
try {
  let cartOpenBtn = document.querySelector(".cart-open-btn");
  let cartDrawer = document.querySelector(".custom-cart-drawer");
  let cartDrawerWrapper = document.querySelector(".custom-cart-container");
  let cartCloseBtn = document.querySelector(".custom-cart-drawer-top svg");

  cartOpenBtn.addEventListener("click", () => {
    if (window.location.href.includes("/cart")) return;
    cartDrawer.classList.add("cart-drawer-open");
    cartDrawerWrapper.classList.add("drawer-wrapper-open");
  });

  cartCloseBtn.addEventListener("click", () => {
    cartDrawer.classList.remove("cart-drawer-open");
    cartDrawerWrapper.classList.remove("drawer-wrapper-open");
  });

  cartDrawerWrapper.addEventListener("click", (e) => {
    if (e.target.closest(".custom-cart-drawer")) return;
    e.stopPropagation();
    cartDrawer.classList.remove("cart-drawer-open");
    cartDrawerWrapper.classList.remove("drawer-wrapper-open");
  });
} catch (error) {
  console.log(error);
}

//Quantity
try {
  let plusBtn = document.querySelector(".custom-product-qty-plus-btn");
  let minusBtn = document.querySelector(".custom-product-qty-minus-btn");
  let qtyInput = document.querySelector(".product-page-qty");
  // let maxInputValue = qtyInput.getAttribute("data-max");

  plusBtn.addEventListener("click", () => {
    // if (qtyInput.value <= maxInputValue) {
    qtyInput.value = Number(qtyInput.value) + 1;
    // }
  });

  minusBtn.addEventListener("click", () => {
    if (qtyInput.value > 1) {
      qtyInput.value = Number(qtyInput.value) - 1;
    }
  });
} catch (error) {
  console.log(error);
}

//Product ADD TO CART || BUY NOW
try {
  let product = document.querySelector(".custom-product-page-wrapper");
  // let productID = product ? product.getAttribute("product-id") : null;
  let productVariant = product
    ? JSON.parse(product.getAttribute("product-variants"))
    : null;
  let cartBottom = document.querySelector(".custom-cart-drawer-bottom");
  let cartExtra = document.querySelector(".custom-cart-drawer-extra");
  let cartDrawer = document.querySelector(".custom-cart-drawer");
  let cartDrawerWrapper = document.querySelector(".custom-cart-container");
  let buyButton = document.querySelector(".buy-btn");
  // let productRemoveBtn = document.querySelector(".custom-cart-item-buttons svg");

  function showNotification(msg) {
    let notificationWrapper = document.querySelector(
      ".custom-notification-wrapper",
    );
    notificationWrapper.style.opacity = "1";
    notificationWrapper.style.pointerEvents = "all";
    notificationWrapper.querySelector("p").textContent = msg.description;

    setTimeout(() => {
      notificationWrapper.style.opacity = "0";
      notificationWrapper.style.pointerEvents = "none";
    }, 5000);
  }

  async function ADDTOCART(id, qty, button) {
    try {
      let formData;
      // ✅ ONLY for main product
      // console.log(id, id.length);
      if (button.classList.contains("main-product-atc")) {
        let sellingPlan = document.querySelector(
          '[name="selling_plan"]',
        )?.value;

        console.log("Selling Plan:", sellingPlan);

        formData = {
          items: [
            {
              id: id,
              quantity: qty,
              ...(sellingPlan && { selling_plan: sellingPlan }),
            },
          ],
        };
      } else {
        if (id.length > 0) {
          formData = {
            items: id.map((singleId) => ({
              id: singleId,
              quantity: qty,
            })),
          };
        } else {
          formData = {
            items: [{ id: id, quantity: qty }],
          };
        }
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        showNotification(data);
        return false;
      }

      console.log("Added to cart:", data);
      await updateCartDrawer();
      return true;
    } catch (err) {
      console.error("Error:", err);
    }
  }

  async function updateCartDrawer() {
    let data = await fetch("/?section_id=custom-cart-drawer");
    let text = await data.text();
    // console.log(text);
    let DIV = document.createElement("DIV");
    DIV.innerHTML = text;
    cartBottom = document.querySelector(".custom-cart-drawer-bottom");
    cartExtra = document.querySelector(".custom-cart-drawer-extra");
    let updatedCartBottom = DIV.querySelector(".custom-cart-drawer-bottom");
    let updatedCartExtra = DIV.querySelector(".custom-cart-drawer-extra");

    if (cartBottom && updatedCartBottom) {
      cartBottom.innerHTML = updatedCartBottom.innerHTML;
    }

    if (cartExtra && updatedCartExtra) {
      cartExtra.innerHTML = updatedCartExtra.innerHTML;
    }

    // Update Cart Count
    const cart = await fetch("/cart.js").then((res) => res.json());
    document.querySelector(".cart-count-span").textContent = cart.item_count;
  }

  function cartOpen() {
    cartDrawer.classList.add("cart-drawer-open");
    cartDrawerWrapper.classList.add("drawer-wrapper-open");
  }

  function getVariantID() {
    let radios = document.querySelectorAll(
      ".variant-option input[type='radio']:checked",
    );
    // if (!radios) return;
    let selectedVariant = [];

    radios.forEach((radio) => {
      selectedVariant.push(radio.value);
    });

    console.log(selectedVariant);
    console.log(productVariant);

    if (productVariant.length == 1) {
      console.log(productVariant[0]);
      return productVariant[0];
    } else {
      const matchedVariant = productVariant.find((v) =>
        v.options.every((opt, i) => opt === selectedVariant[i]),
      );
      return matchedVariant;
    }
  }

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".a-t-c-btn");
    if (!btn) return;
    let productID = btn ? Number(btn.getAttribute("product-id")) : false;

    // console.log("sdghjkl");
    if (!productID) {
      let variant = getVariantID();
      let variantID = variant ? variant.id : null;
      if (!variantID) return;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty, btn);
      if (added) cartOpen();
      return;
    }

    let qty = 1;
    let added = await ADDTOCART(productID, qty, btn);
    if (added) cartOpen();
  });

  document.addEventListener("click", async (e) => {
    let btn = e.target.closest(".buy-btn");
    if (!btn) return;

    let productID = btn ? btn.getAttribute("product-id") : false;
    if (!productID) {
      let variantID = getVariantID().id ? getVariantID().id : null;
      let qty = document.querySelector(".product-page-qty")
        ? Number(document.querySelector(".product-page-qty").value)
        : 1;
      let added = await ADDTOCART(variantID, qty, btn);
      if (added) window.location.href = "/checkout";
    }

    let qty = document.querySelector(".product-page-qty")
      ? Number(document.querySelector(".product-page-qty").value)
      : 1;
    let added = await ADDTOCART(productID, qty);
    if (added) window.location.href = "/checkout";
  });

  document.addEventListener("click", async (e) => {
    let remove_btn = e.target.closest(".custom-cart-item-buttons svg");
    if (!remove_btn) return;
    let product_id = remove_btn.getAttribute("remove-product-id");
    cartBottom.style.opacity = 0.6;

    //Ajax Api Template
    const payload = {
      id: product_id,
      quantity: 0,
    };
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      const result = await response.json();
      console.log("✅ Removed form cart:", result);
      await updateCartDrawer();
      cartBottom.style.opacity = 1;
      return result;
    } catch (error) {
      console.error("❌ Failed to change cart item quantity:", error);
      return null;
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const variants = productVariant;
    if (!variants || !variants.length) return;
    let radios = document.querySelectorAll("input[type='radio']");
    const sizeRadios = document.querySelectorAll('input[name="option-1"]');
    const colorRadios = document.querySelectorAll('input[name="option-2"]');

    /* ----------------------------
     1️⃣ Select first available variant
  ---------------------------- */
    const firstAvailable = variants.find((v) => v.available);
    if (!firstAvailable) {
      radios.forEach((r) => {
        r.disabled = true;
        r.closest(".variant-option").classList.add("variant-out-of-stock");
      });

      const atcBtn = document.querySelectorAll(
        ".custom-product-button-wrapper .a-t-c-btn",
      );
      const buyBtn = document.querySelectorAll(
        ".custom-product-button-wrapper .buy-btn",
      );

      if (atcBtn) {
        atcBtn.forEach((btn) => {
          btn.textContent = "Out Of Stock";
          btn.classList.add("addtocart-class");
        });
      }

      if (buyBtn)
        buyBtn.forEach((btn) => {
          btn.style.display = "none";
        });
    }

    const selectRadio = (name, value) => {
      const r = document.querySelector(
        `input[name="${name}"][value="${value}"]`,
      );
      if (r) r.checked = true;
    };

    selectRadio("option-1", firstAvailable.options[0]);
    selectRadio("option-2", firstAvailable.options[1]);

    /* ----------------------------
     2️⃣ Update SIZE availability
  ---------------------------- */
    const updateSizes = () => {
      sizeRadios.forEach((sizeRadio) => {
        const sizeValue = sizeRadio.value;

        const hasAnyAvailable = variants.some(
          (v) => v.available && v.options[0] === sizeValue,
        );

        sizeRadio.disabled = !hasAnyAvailable;
        sizeRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !hasAnyAvailable);
      });
    };

    /* ----------------------------
     3️⃣ Update COLOR availability
  ---------------------------- */
    const updateColors = () => {
      const selectedSize = document.querySelector(
        'input[name="option-1"]:checked',
      )?.value;

      if (!selectedSize) return;

      colorRadios.forEach((colorRadio) => {
        const colorValue = colorRadio.value;

        const isAvailable = variants.some(
          (v) =>
            v.available &&
            v.options[0] === selectedSize &&
            v.options[1] === colorValue,
        );

        colorRadio.disabled = !isAvailable;
        colorRadio
          .closest(".variant-option")
          ?.classList.toggle("variant-out-of-stock", !isAvailable);
      });

      // Auto-select first available color
      const checkedColor = document.querySelector(
        'input[name="option-2"]:checked',
      );
      if (!checkedColor || checkedColor.disabled) {
        const firstAvailableColor = Array.from(colorRadios).find(
          (r) => !r.disabled,
        );
        if (firstAvailableColor) firstAvailableColor.checked = true;
      }
    };

    /* ----------------------------
     4️⃣ Init
  ---------------------------- */
    updateSizes();
    updateColors();

    /* ----------------------------
     5️⃣ Events
  ---------------------------- */
    sizeRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateColors();
      });
    });
  });

  // Auto Select Variant
  function autoSelectVariant() {
    document.addEventListener("DOMContentLoaded", () => {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get("variant");
      if (variantId) {
        const selectedVariant = productVariant.find((v) => v.id == variantId);
        // console.log(selectedVariant);

        if (selectedVariant.available) {
          let inputRadio = document.querySelector(
            `input[type='radio'][value='${selectedVariant.title}']`,
          );
          if (inputRadio) {
            setTimeout(() => {
              inputRadio.checked = true;
            }, 1000);

            return;
          }
        }
        // console.log(inputRadio);
      }
    });
  }
  autoSelectVariant();
} catch (error) {
  console.log(error);
}

// Price Change || Variant Image
try {
  setTimeout(() => {
    let variantRadios = document.querySelectorAll(
      ".variant-option input[type='radio']",
    );
    let product = document.querySelector(".custom-product-page-wrapper");
    // let productID = product ? product.getAttribute("product-id") : null;
    let productVariant = product
      ? JSON.parse(product.getAttribute("product-variants"))
      : null;
    let productPrice = document.querySelector(".product-page-price");
    let productComparePrice = document.querySelector(
      ".product-page-compare-price",
    );

    variantRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updatePrice();
        updateVariant();
      });
    });

    function updatePrice() {
      try {
        let slsProductPrice = document
          .querySelector("[data-one-time-option-radio]")
          ?.parentElement?.querySelector(".seal-money");
        // console.log(slsProductPrice);
        let slsProductComparePrice = document
          .querySelector("[data-selling-plan-group-option-radio]")
          ?.parentElement?.querySelector(".sls-price");

        // console.log(slsProductComparePrice, slsProductPrice);

        let selectedRadiosArr = [];
        let selectedRadios = document.querySelectorAll(
          ".variant-option input[type='radio']:checked",
        );
        selectedRadios.forEach((radio) => {
          selectedRadiosArr.push(radio.value);
        });
        // console.log(selectedRadiosArr);

        const matchedVariant = productVariant.find((v) =>
          v.options.every((opt, i) => opt === selectedRadiosArr[i]),
        );

        // console.log(matchedVariant);
        if (!matchedVariant) return;
        let newPrice = matchedVariant.price / 100;
        let newComparePrice = matchedVariant.compare_at_price / 100;

        const price = newPrice;
        const discount = 10;

        const finalPrice = price - (price * discount) / 100;

        // console.log(finalPrice);

        if (productPrice) {
          productPrice.innerHTML = `${product.getAttribute(
            "shop-curreny",
          )} ${newPrice.toFixed(2)}`;
        }

        // if (slsProductPrice) {
        //   slsProductPrice.innerHTML = `${product.getAttribute(
        //     "shop-curreny",
        //   )} ${newPrice.toFixed(2)}`;
        // }

        if (productComparePrice) {
          if (newComparePrice > newPrice) {
            productComparePrice.classList.remove("compare-price-hide");
            productComparePrice.innerHTML = `${product.getAttribute("shop-curreny")} ${newComparePrice.toFixed(
              2,
            )}`;
          } else {
            productComparePrice.innerHTML = ``;
          }
        }

        // if (slsProductComparePrice) {
        //   // if (newComparePrice > newPrice) {
        //   slsProductComparePrice.classList.remove("compare-price-hide");
        //   slsProductComparePrice.innerHTML = `
        //       <span>${product.getAttribute("shop-curreny")} ${finalPrice.toFixed(2)}</span>
        //       <span style="text-decoration:line-through; text-decoration-color: grey; color: grey; padding-left: 4px;">${product.getAttribute("shop-curreny")} ${newPrice.toFixed(2)}</span>
        //     `;
        //   // } else {
        //   //   slsProductComparePrice.innerHTML = ``;
        //   // }
        // }
      } catch (error) {
        console.log(error);
      }
    }

    function updateVariant() {
      let selectedOptions = [];

      document
        .querySelectorAll(".variant-option input[type='radio']:checked")
        .forEach((select) => {
          selectedOptions.push(select.value);
        });

      let matchedVariant = productVariant.find((v) =>
        selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt),
      );

      if (!matchedVariant || !matchedVariant.featured_media) return;

      let targetedMediaID = matchedVariant.featured_media.id;

      let swiperEl = document.querySelector(
        ".custom-product-page-swiper-container",
      );
      if (!swiperEl || !swiperEl.swiper) return;

      let targetedSlide = swiperEl.querySelector(
        `swiper-slide[data-media-id="${targetedMediaID}"]`,
      );

      if (!targetedSlide) return;

      let index = [...swiperEl.swiper.slides].indexOf(targetedSlide);

      swiperEl.swiper.slideToLoop
        ? swiperEl.swiper.slideToLoop(index)
        : swiperEl.swiper.slideTo(index);
    }

    document.querySelectorAll(".sls-option-container").forEach((radio) => {
      radio.addEventListener("click", () => {
        // document.querySelectorAll(".sls-custom-radio").forEach((r) => {
        setTimeout(() => {
          updatePrice();
        }, 100);
        // });
      });
    });

    updatePrice();
  }, 2500);
} catch (error) {
  console.log(error);
}

//Enlarger
try {
  let enlargerOpenBtn = document.querySelectorAll(
    ".custom-product-img-enlarger-icon",
  );
  let enlargerCloseBtn = document.querySelector(".enlarger-close-btn");
  let enlargerWrapper = document.querySelector(".custom-product-img-enlarger");
  let enlargerCon = document.querySelector(
    ".custom-product-img-enlarger-container",
  );

  enlargerOpenBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      let closestImgSrc = btn.parentElement
        .querySelector("img")
        .getAttribute("src");
      // console.log(closestImgSrc);
      let img = document.createElement("img");
      img.setAttribute("draggable", "false");
      img.setAttribute("src", closestImgSrc);
      // console.log(img);
      img.classList.add("product-img-class");
      enlargerWrapper.innerHTML = "";
      enlargerWrapper.append(img);
      enlargerCon.classList.add("custom-product-img-enlarger-container-class");
      enableImageDrag(img);
    });
  });

  enlargerCloseBtn.addEventListener("click", () => {
    enlargerCon.classList.remove("custom-product-img-enlarger-container-class");
  });

  function enableImageDrag(img) {
    let isDraggable = false;
    let startX, startY, initialLeft, initialTop;

    img.style.position = "absolute";
    img.style.top = "50%";
    img.style.left = "50%";
    img.style.transform = "translate(-50%, -50%) scale(1.5)";
    img.style.cursor = "grab";

    img.addEventListener("mousedown", (e) => {
      isDraggable = true;
      img.style.transition = "none";
      img.style.cursor = "grabbing";

      // Get current position of the image (after transforms)
      const rect = img.getBoundingClientRect();

      // Calculate starting mouse position and element offsets
      startX = e.clientX;
      startY = e.clientY;

      // Compute initial top/left in pixels relative to parent container
      const computedStyle = window.getComputedStyle(img);
      initialLeft = parseFloat(computedStyle.left);
      initialTop = parseFloat(computedStyle.top);

      document.body.style.userSelect = "none";
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDraggable) return;

      // Delta from initial click
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      // Move image smoothly while maintaining scale
      img.style.left = `${initialLeft + dx}px`;
      img.style.top = `${initialTop + dy}px`;
      img.style.transform = `translate(-50%, -50%) scale(1.5)`;
    });

    window.addEventListener("mouseup", () => {
      if (isDraggable) {
        isDraggable = false;
        img.style.cursor = "grab";
        document.body.style.userSelect = "";
        img.style.transition = ".3s ease";
        // Snap back to center if desired
        img.style.top = `50%`;
        img.style.left = `50%`;
        img.style.transform = `translate(-50%, -50%) scale(1.5)`;
      }
    });
  }
} catch (error) {
  console.log(error);
}

// review swiper
let reviewSwiperCon = document.querySelectorAll(".custom-review-swiper-con");
reviewSwiperCon.forEach((con) => {
  function responsiveSwiper() {
    let width = window.innerWidth;
    if (width > 1024) {
      con.setAttribute("slides-per-view", "4");
    } else if (width > 768) {
      con.setAttribute("slides-per-view", "3");
    } else if (width > 325) {
      con.setAttribute("slides-per-view", "1.3");
    }
  }

  window.addEventListener("resize", responsiveSwiper);
  document.addEventListener("DOMContentLoaded", responsiveSwiper);
});
